import type {
  BulkValidateInventoriesBody,
  BulkValidateInventoriesResponse,
  InventoriesAggregatedStats,
  InventoryDetail,
  InventorySummary,
} from '@gozoki/api-types'
import { gozokiApi, gozokiApiWithAuth } from '../gozokiApi'

export const fetchInventories = async () => {
  const response = await gozokiApi.get<InventorySummary[]>('/inventories/')
  return response.data
}

export const fetchInventory = async (id: number) => {
  const response = await gozokiApiWithAuth.get<InventoryDetail>(`/inventories/${id}`)
  return response.data
}

export const fetchStoreInventories = async (id: number) => {
  const response = await gozokiApiWithAuth.get<InventorySummary[]>(`/stores/${id}/inventories`)
  return response.data
}

export const fetchStoreInventoriesAggregatedStats = async (
  storeId: number,
  startDate: string,
  endDate: string,
) => {
  const response = await gozokiApiWithAuth.get<InventoriesAggregatedStats>(
    `/stores/${storeId}/inventories/aggregated-stats`,
    { params: { startDate, endDate } },
  )
  return response.data
}

export const updateUnScannableProducts = async (data: {
  id: number
  productRef: string
  count: number
}) => {
  const { id, productRef, count } = data
  return gozokiApiWithAuth.post<InventoryDetail>(`/inventories/${id}/unscannable-products`, {
    count,
    productRef,
  })
}

export const updateInventoryDescription = async (data: {
  id: number
  label: string
  comment: string
}) => {
  const { id, label, comment } = data
  return gozokiApiWithAuth.post(`inventories/${id}/description`, { comment, label })
}

export const updateInventoryStatus = async (data: {
  id: number
  status: 'pending' | 'validated' | 'canceled'
}) => {
  const { id, status } = data
  return gozokiApiWithAuth.post(`inventories/${id}/status`, { status })
}

/** Validation en masse depuis l'écran Inventaires (spec v2 §6.3) : séquentielle côté serveur. */
export const bulkValidateInventories = async (body: BulkValidateInventoriesBody) => {
  const response = await gozokiApiWithAuth.post<BulkValidateInventoriesResponse>(
    'inventories/bulk-validate',
    body,
  )
  return response.data
}

export const updateInventoryFinishedStatus = async (data: { id: number; isFinished: boolean }) => {
  const { id, isFinished } = data
  return gozokiApiWithAuth.post(`inventories/${id}/finished-status`, { isFinished })
}
